<template>
      <v-container>
    <v-row cols="12" class="justify-center">
      <v-col sm="6">
        <v-col sm="12" >
            <v-row cols="12">
                <v-col sm="9">
                    <div class="text text-3xl mt-5 pb-0">
                      License Agreement
                    </div>          
                    
                </v-col>
                <v-col sm="3">
                    <v-img class="mt-5 ml-auto pb-0" contain width="80" position="center center" src="../../public/logo_with_tm.png" ></v-img>
                </v-col>
            </v-row>
            <v-row cols="12">
                <v-col sm="12">
                    <div class="text">
                      Please click “accept” to continue to accountexec.
                    </div>
                </v-col>
            </v-row>
        </v-col>

        <v-container fluid>
        <v-row>
            <v-col
            cols="12"
            sm="12"
            >
            <div class="text eula-display">
                {{ eula }}
            </div>
            </v-col>
            <v-col cols="6">

                <v-btn
                    class="white--text" color="blue-grey lighten-3"
                    type="submit"
                    name="submit"
                    :disabled="sendingEulaRequest"
                    @click="handleDeclineEula()"
                    block
                >
                    back
                </v-btn>
            </v-col>
            <v-col cols="6">
                <v-btn
                    class="white--text" color="blue"
                    type="submit"
                    name="submit"
                    :disabled="sendingEulaRequest || !eulaLoaded"
                    @click="handleAcceptEula()"
                    block
                >
                    Accept
                </v-btn>
            </v-col>

        </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

  <script>
  // @ is an alias to /src

import axios from 'axios';


  export default {
    name: 'Eul',
    components: {
    },
    data () {
        return {
            eula: "Hi, I'm a eula agreement. Accept me as your master.",
            sendingEulaRequest: false,
            eulaLoaded: false,
            eulaContentId: 1,
        }
    },
    mounted () {
        this.retrieveEULA()
    },
    methods: {
        handleDeclineEula () {
            this.$router.push('/logout')
        },
        handleAcceptEula () {
            this.sendingEulaRequest = true
            axios({
                method: "post",
                url: this.$store.getters.baseURL + '/api/user/accept_eula',
                headers: {
                    "Authorization": `Token ${this.$store.state.userToken}`
                },
                data: this.clientIds
            })
            .then(res => {
                if (res.status === 200) {
                    this.$store.commit('setUserData', { accepted_eula: true })
                    const forcePasswordReset = this.$store.getters.requiresPasswordReset
                    if (forcePasswordReset) {
                        this.$router.push('/change_password').catch(() => {});
                    } else if (this.$store.getters.needsPhoneProof) {
                        this.$router.push('/kickoff').catch(() => {});
                    } else if (this.$store.getters.needsEmployer) {
                        this.$router.push('/profile').catch(() => {});
                    } else {
                        this.$router.push('/').catch(() => {});
                    }
                }
            })
            .catch( () => {
                this.$toast.error("Unable to accept the EULA for some reason.")
            })
            .finally( () => {
                this.sendingEulaRequest = false
            })
        },
        retrieveEULA () {
            const url = `${this.$store.getters.baseURL}/api/content/${this.eulaContentId}`
            axios({
                method: 'get',
                url: url,
                headers: {
                    'Authorization': `Token ${this.$store.state.userToken}`
                }
            })
            .then(res => {
                this.eulaLoaded = true
                this.eula = res.data.content
            })
        }
    }
  }
</script>

<style scoped>
.eula-display {
    padding: 1em;
    border: 1px solid #d1d1d1;
    border-radius: 8px;
    height: 400px;
    overflow-y: auto;
    box-shadow: 1px 1px 23px -3px rgb(0 0 0 / 31%) inset;
    -webkit-box-shadow: 1px 1px 12px -3px rgb(0 0 0 / 31%) inset;
}
</style>
